(() => {
  if (window.andCharliePurchaseConfirmationInitialized) return;
  window.andCharliePurchaseConfirmationInitialized = true;

  const attributeName = '返品・交換ポリシー確認';
  const confirmedValue = '確認済み';
  let requestedConfirmation = null;
  let saving = false;
  let revision = 0;
  let saveQueue = Promise.resolve();
  let cartWasEmptied = false;

  function getConfirmations() {
    return Array.from(
      document.querySelectorAll('[data-andcharlie-purchase-confirmation]')
    );
  }

  function getCheckboxes() {
    return Array.from(
      document.querySelectorAll('[data-andcharlie-purchase-confirmation-checkbox]')
    );
  }

  function getErrors() {
    return Array.from(
      document.querySelectorAll('[data-andcharlie-purchase-confirmation-error]')
    );
  }

  function getCheckoutButtons() {
    return [
      document.getElementById('CartDrawer-Checkout'),
      document.getElementById('checkout')
    ].filter(Boolean);
  }

  function getDynamicCheckoutButtons() {
    return document.getElementById('AndCharlieDynamicCheckoutButtons');
  }

  function isConfirmed() {
    if (requestedConfirmation !== null) return requestedConfirmation;
    const checkboxes = getCheckboxes();

    if (checkboxes.length === 0) return false;

    return checkboxes.some((checkbox) => checkbox.checked);
  }

  function syncCheckboxes(checked, sourceCheckbox = null) {
    getCheckboxes().forEach((checkbox) => {
      if (checkbox === sourceCheckbox) return;
      checkbox.checked = checked;
    });
  }

  function hideErrors() {
    getErrors().forEach((error) => {
      error.hidden = true;
    });
  }

  function showErrorFor(checkbox) {
    const confirmation = checkbox?.closest(
      '[data-andcharlie-purchase-confirmation]'
    );

    const error = confirmation?.querySelector(
      '[data-andcharlie-purchase-confirmation-error]'
    );

    if (error) {
      error.hidden = false;
    }
  }

  function updatePurchaseState(checked) {
    getCheckoutButtons().forEach((button) => {
      const cartIsEmpty = button.hasAttribute('data-cart-empty');

      button.disabled = cartIsEmpty || !checked || saving;
    });

    const dynamicCheckoutButtons = getDynamicCheckoutButtons();

    if (dynamicCheckoutButtons) {
      dynamicCheckoutButtons.hidden = !checked || saving;
    }

    if (checked) {
      hideErrors();
    }
  }

  function saveConfirmation(checked) {
    const requestRevision = ++revision;
    saving = true;
    updatePurchaseState(checked);
    // Serialize updates so a slower earlier response cannot overwrite the latest choice.
    saveQueue = saveQueue.then(async () => {
      if (requestRevision !== revision) return;
      try {
        const response = await fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              [attributeName]: checked ? confirmedValue : ''
            }
          })
        });

        if (!response.ok) {
          throw new Error(`Cart update failed with status ${response.status}`);
        }
      } catch {
        if (requestRevision !== revision) return;
        requestedConfirmation = false;
        syncCheckboxes(false);
        getErrors().forEach((element) => {
          element.textContent = '確認内容を保存できませんでした。通信状態を確認し、もう一度チェックを入れてください。';
          element.hidden = false;
        });
      } finally {
        if (requestRevision === revision) {
          saving = false;
          updatePurchaseState(isConfirmed());
        }
      }
    });
  }

  function focusConfirmation(checkbox) {
    if (!checkbox) return;

    checkbox.focus();

    checkbox.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest(
      '[data-andcharlie-purchase-confirmation-checkbox]'
    );

    if (!checkbox) return;

    const checked = checkbox.checked;
    cartWasEmptied = false;
    requestedConfirmation = checked;

    syncCheckboxes(checked, checkbox);
    updatePurchaseState(checked);
    saveConfirmation(checked);
  });

  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest(
        '#CartDrawer-Checkout, #checkout'
      );

      if (!checkoutButton) return;

      const confirmed = isConfirmed();

      if (confirmed && !saving) return;

      event.preventDefault();

      const location = checkoutButton.id === 'CartDrawer-Checkout'
        ? 'drawer'
        : 'page';

      const checkbox = document.querySelector(
        `[data-andcharlie-purchase-confirmation][data-location="${location}"] [data-andcharlie-purchase-confirmation-checkbox]`
      );

      showErrorFor(checkbox);
      focusConfirmation(checkbox);
    },
    true
  );

  document.addEventListener('submit', (event) => {
    if (!['cart', 'CartDrawer-Form'].includes(event.target.id)) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (isConfirmed() && !saving) return;
    event.preventDefault();
    const location = event.target.id === 'CartDrawer-Form' ? 'drawer' : 'page';
    const checkbox = document.querySelector(
      `[data-andcharlie-purchase-confirmation][data-location="${location}"] [data-andcharlie-purchase-confirmation-checkbox]`
    );
    showErrorFor(checkbox);
    focusConfirmation(checkbox);
  }, true);

  function initialize() {
    if (getConfirmations().length === 0) resetEmptyCart();
    const confirmed = isConfirmed();

    syncCheckboxes(confirmed);
    updatePurchaseState(confirmed);
  }

  document.addEventListener('DOMContentLoaded', initialize);

  document.addEventListener('shopify:section:load', initialize);

  function resetEmptyCart() {
    if (cartWasEmptied) return;
    cartWasEmptied = true;
    const mustClearSavedConfirmation = isConfirmed() || saving;
    requestedConfirmation = false;
    syncCheckboxes(false);
    if (mustClearSavedConfirmation) saveConfirmation(false);
    updatePurchaseState(false);
  }

  // Dawn provides authoritative cart data after quantity changes and item removal.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData?.item_count === 0) {
        resetEmptyCart();
      } else if (event.cartData?.item_count > 0) {
        cartWasEmptied = false;
      }
    });
  }

  const observer = new MutationObserver(() => {
    initialize();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
